const maxChars = 320;

const countChars = ( event ) => {
  const input = event.target;
  if(input.value.length >= maxChars){
    input.value = input.value.slice(0, maxChars);
  }
  const charsLeft = Math.max(0, maxChars - input.value.length);
  document.getElementById('gift-note-chars').innerText = `${charsLeft}`;
};

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('gift-note-chars').innerText = `${maxChars}`;
  document.querySelector('.gift-note-limit').addEventListener('input', countChars);
});
